import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SidePanelService } from '../../services/side-panel.service';
import { SidePanelComponent } from '../side-panel/side-panel.component';

@Component({
    selector: 'app-side-panel-wrapper',
    templateUrl: './side-panel-wrapper.component.html',
    styleUrls: ['./side-panel-wrapper.component.scss'],
	imports: [SidePanelComponent],
    providers: [SidePanelService],
    standalone: true
})
export class SidePanelWrapperComponent {

	@Input() side: 'left' | 'right' = 'right';
	@Input() enterSubmit: boolean = true;
	@Input() opened: boolean = false;
	@Input() closeIcon: string = 'close';
	@Input() zIndex: number = 2000;

	@Output('closePanel') closeEmitter: EventEmitter<void> = new EventEmitter<void>();

}

